import React from "react";
import { useIntl } from "react-intl";

export default function SummerGames() {
  const intl = useIntl();

  return (
    <>
      <div>{intl.formatMessage({ id: "navbar.summerGames" })}</div>
    </>
  );
}
